export default __webpack_public_path__ + "static/media/regulatory--turn-left-or-u-turn--g1.8f5028c9.png";